const RequirementLookup = {
    WIND: {
        icon: 'wind',
        description: 'Wind turbines running for one year',
        info: '',
        calc (input) {
            return (input / 8573631).toFixed(8);
        }
    },
    // COAL: {
    //     icon: 'coal',
    //     description: 'Pounds of coal combusted by power plant',
    //     info: '',
    //     calc (input) {
    //         return (input / 6189.64 * 2204.62).toFixed(8);
    //     }
    // },
    SOLAR: {
        icon: 'solar',
        description: 'Football fields of solar panels for one year',
        info: '',
        calc (input) {
            return input !== '' ? (input / 1380498).toFixed(8) : 0;
        }
    },
};

export default RequirementLookup;



/** WEBPACK FOOTER **
 ** ./src/redux/modules/requirements/RequirementLookup.js
 **/